<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-8.16,787.5v10l8.66,5l8.66-5v-10l-8.66-5L-8.16,787.5z M-0.35,791.35l2.23-2.79h-2.17v-0.76h3.3v0.72l-2.26,2.83h2.26
	v0.76h-3.36V791.35z M6.82,788.56H4.53v0.92h2.1v0.75h-2.1v1.11h2.39v0.78H3.65v-4.32h3.17V788.56z M-1.78,787.79h0.9v4.32h-0.9
	V787.79z M-5.06,790.78c0.03,0.2,0.08,0.34,0.16,0.44c0.15,0.18,0.4,0.27,0.75,0.27c0.21,0,0.39-0.02,0.52-0.07
	c0.25-0.09,0.38-0.26,0.38-0.5c0-0.14-0.06-0.25-0.19-0.33c-0.13-0.08-0.32-0.14-0.59-0.2l-0.46-0.1c-0.45-0.1-0.76-0.21-0.93-0.33
	c-0.29-0.2-0.44-0.51-0.44-0.93c0-0.39,0.14-0.71,0.42-0.96s0.69-0.38,1.24-0.38c0.46,0,0.84,0.12,1.16,0.36s0.49,0.59,0.51,1.05
	h-0.87c-0.02-0.26-0.13-0.44-0.34-0.55c-0.14-0.07-0.32-0.11-0.52-0.11c-0.23,0-0.42,0.05-0.56,0.14s-0.21,0.22-0.21,0.39
	c0,0.15,0.07,0.27,0.21,0.35c0.09,0.05,0.28,0.11,0.56,0.18l0.74,0.18c0.33,0.08,0.57,0.18,0.74,0.31c0.26,0.2,0.39,0.5,0.39,0.88
	c0,0.39-0.15,0.72-0.45,0.98s-0.73,0.39-1.28,0.39c-0.56,0-1-0.13-1.33-0.38s-0.48-0.61-0.48-1.06H-5.06z M-0.75,795.18v-0.57
	c0.26-0.01,0.45-0.03,0.55-0.05c0.17-0.04,0.3-0.11,0.41-0.22c0.07-0.08,0.13-0.18,0.16-0.3c0.02-0.08,0.03-0.13,0.03-0.17H1.1v4.25
	H0.25v-2.93H-0.75z"/>
</svg>

</template>